import { FIQAssist } from "../app"
import { Directive, Inject, NgUtils } from "@fiqas/angular-utils";
import { CacheService } from "../services/cache";
@Directive({
    selector: WatchSize.Selector,
    module: FIQAssist
})
export class WatchSize {
    public static Selector = "watchSize";
    public static SizeEventName = "sizeEventName";
    public static SizeEventHandler = "sizeEventHandler";
    constructor(
        @Inject('$window') private $window: ng.IWindowService,
        @Inject('$parse') private $parse: ng.IParseService,
        @Inject() private cacheService: CacheService
    ) {
    }

    public link(scope: ng.IScope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes): void {
        var sizeEventName: string = attrs[WatchSize.SizeEventName];
        // var sizeEventHandler = this.$parse(attrs[WatchSize.SizeEventHandler]);
        var sizeEventArgs: { height: number, width: number } = this.cacheService.getValue<{ height: number, width: number }>(`size:${sizeEventName}`);
        var sizeHeaderEventArgs: { height: number, width: number } = this.cacheService.getValue<{ height: number, width: number }>(`size:Header`);
        var action = () => {
            if (sizeHeaderEventArgs && sizeEventArgs) {
                var rightspace = (sizeHeaderEventArgs.width - 1200) / 2;
                if (sizeEventArgs.width < rightspace) element.css('max-width', `100%`);
                else element.css('max-width', `calc(100% - ${sizeEventArgs.width - rightspace}px)`);
            }
        }
        scope.$root.$on(`size:${sizeEventName}`, (event, args) => {
            sizeEventArgs = args;
            action();
        });
        scope.$root.$on(`size:Header`, (event, args) => {
            sizeHeaderEventArgs = args;
            action();
        });
        action();
    }
}